module.exports = __webpack_public_path__ + "img/the-bell.5d2db1ae.webp";